import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { toRound } from '../../../../utils/get-rounded-number.util';
import { toNumber } from '../../../../utils/to-number.util';

export type ItemCellProps = {
  change?: number;
  title: ReactNode | string;
  value: number | string;
};

export const ItemCell: FC<ItemCellProps> = ({ value, change, title }) => {
  return (
    <div className="centered flex w-full flex-col gap-3 border border-t-0 border-gray-100 p-3">
      <span className="max-w-full truncate text-label-md font-medium text-gray-700">{title}</span>
      <span className="text-sm font-[450] text-gray-700">
        {value ? value.toLocaleString('en-US') : '-'}
      </span>
      {change ? (
        <span
          className={twMerge(
            'rounded-2xl px-[6px] py-[2px] text-xs font-medium',
            change > 0
              ? 'bg-forest-50 text-forest-600'
              : change < 0
                ? 'bg-fireside-50 text-fireside-600'
                : 'bg-gray-50 text-gray-400',
          )}
        >
          {change > 0
            ? `+${toRound(toNumber(change) * 100).toLocaleString('en-US')}%`
            : change < 0
              ? `${toRound(toNumber(change) * 100)}%`
              : `00`}
        </span>
      ) : (
        <span
          className={twMerge(
            'rounded-2xl bg-gray-50 px-[6px] py-[2px] text-xs font-medium text-gray-400',
          )}
        >
          00
        </span>
      )}
    </div>
  );
};
